import { Button } from "@nextui-org/react";
import { useState } from "react";
import { toast } from "react-toastify";
import { FAQ, FAQData } from "@/types";
import { BackArrowIcon } from "@/assets/icons/admin";
import { deleteIcon } from "@/constants";
import DeleteModal from "./ModalDelete";
import { useCreateFAQ, useEditFAQ } from "@/services/faq.service";

interface AddNewAccountViewProps {
  onCancel: () => void;
  itemData?: Partial<FAQ>;
}

const EditFaq: React.FC<AddNewAccountViewProps> = ({ onCancel, itemData }) => {
  const updateFAQ = useEditFAQ();
  const { mutate: createFAQ } = useCreateFAQ();

  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState(itemData?.title);
  const [description, setDescription] = useState(itemData?.content);

  const id = itemData?.id;

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "title") {
      setTitle(value);
    } else if (name === "description") {
      setDescription(value);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const updateData: Partial<FAQData> = {
      title,
      description,
    };

    if (!id) {
      createFAQ(
        {
          title: updateData.title!,
          description: updateData.description!,
        },
        {
          onSuccess: () => {
            toast.success("FAQ created successfully");
            onCancel();
          },
          onError: (error: any) => {
            toast.error(error?.response?.data?.error);
          },
        },
      );

      return;
    } else {
      updateFAQ.mutate(
        { id: id!, data: updateData },
        {
          onSuccess: () => {
            toast.success("Successfully updated FAQ");
            onCancel();
          },
          onError: (err) => {
            console.error("Error updating faq:", err);
            toast.error("Error updating FAQ");
          },
        },
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="font-ubuntu mb-2 w-full text-center text-2xl font-semibold text-white sm:float-left">
        <span>
          <Button
            isIconOnly
            onClick={onCancel}
            className="transparent-bg float-left ml-[-11px] h-auto w-auto"
          >
            <BackArrowIcon />
          </Button>
          <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
            {id ? "Edit FAQ" : "Add FAQ"}
          </p>
        </span>
      </div>
      <div className="flex w-full flex-col gap-2 sm:gap-6">
        {/* form grid */}
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 w-full">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block font-normal text-white/50"
            >
              Title
            </label>
            <input
              name="title"
              value={title}
              placeholder="Type Here"
              onChange={handleInputChange}
              required
              className="input-bg w-full p-2"
            />
          </div>
        </div>
        <div className="sm:flex sm:flex-row">
          <div className="mt-1 basis-full">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block font-normal text-white/50"
            >
              Description
            </label>
            <textarea
              value={description}
              placeholder="Type Here"
              name="description"
              onChange={handleInputChange}
              rows={5}
              className={`input-bg w-full !cursor-text rounded-md border border-solid p-2`}
              required
            />
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-6">
        <div className="flex flex-col md:flex-row">
          <div className="mt-5 w-fit basis-full">
            <div
              className="float-left flex cursor-pointer flex-row items-center gap-2"
              onClick={() => setIsOpen(true)}
            >
              <img src={deleteIcon} />
              <div className="text-[#FF5E5E]"> Delete</div>
            </div>
          </div>
          <div className="mt-5 w-fit basis-full max-sm:w-full">
            <div className="max-sm:w-full sm:float-right">
              <Button
                type="submit"
                className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-28 pr-32 text-base font-normal sm:pl-20 sm:pr-20"
              >
                <span className="hidden sm:block">Save</span>
                <span className="sm:hidden">Save Changes</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <DeleteModal
          faqId={id!}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            onCancel();
          }}
        />
      )}
    </form>
  );
};

export default EditFaq;
